import { ReactNode } from 'react';
import { BannerSt, ContainerSt, TextSt } from './Notification.css';
import { CloseButton } from './components/CloseButton';
import { Tick } from '@heycar-uikit/icons';

interface Props {
  title: ReactNode;
  type: string;
  onClose?: () => void;
  className?: string;
  color?: string;
  showInfo: boolean;
}

const InfoNotification = ({
  type,
  title,
  onClose,
  className,
  color,
  showInfo,
}: Props) => (
  <BannerSt
    className={className}
    type={type}
    color={color}
    aria-live="assertive"
    aria-atomic="true"
    showInfo={showInfo}
  >
    <ContainerSt>
      <Tick />
      <TextSt>{title}</TextSt>
      <CloseButton ml="auto" width={10} alignSelf="center" onClick={onClose} />
    </ContainerSt>
  </BannerSt>
);

export { InfoNotification };
